import { createStyles } from "@mantine/core";

const useStyles = createStyles((theme) => ({
  wrapper: {
    display: "flex",
  },
  content: {
    display: "flex",
    width: "100%",
    flexDirection: "column",
  },
  title: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#74D588", // rgba(128, 0, 128, 0.50)
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "118px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "30px",
    },
  },
  buttonPRN: {
    height: "50px",
    width: "100px",
    color: "rgba(128, 0, 128, 1)",
    background: "transparent",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    border: "3px solid rgba(128, 0, 128, 1)",
    fontSize: "20px",
    borderRadius: 10,
    fontWeight: "bold",
    gap: "5px",
  },

  detailTitle: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "36px",
    },
    "& button": {
      height: "50px",
      width: "150px",
      color: "#FF0000",
      background: "transparent",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      border: "2px solid #FF0000",
      borderRadius: "25px",
      fontSize: "20px",
      gap: "5px",
      "& img": {
        width: "30px",
        height: "30px",
      },
    },
  },

  btn: {
    marginLeft: "auto",
    marginTop: 50,
  },

  medicationModal: {
    width: 1450,
    overflowY: "hidden",
    // height: 500,
    // "& .mantine-Modal-content": {
    //   height: "300px !important",
    // },
    // "& .mantine-Modal-inner": {
    //   padding: "0px !important",
    // },
    "& .mantine-Paper-root": {
      overflow: "hidden !important",
    },
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
    "& .mantine-Modal-header": {
      display: "none",
    },

    "@media (max-width:400px)": {
      width: "auto",
    },
    "& .mantine-1q36a81": {
      padding: "0",
    },
  },
  mwd: {
    width: "100%",
  },
  mainContentWarpper: {
    width: "100%",
    height: "70vh",
    maxHeight: "900px",
    overflowY: "auto",
  },
  mainContent: {
    width: "100%",
    // height: "100%",
    padding: "3rem 4rem 5rem 8rem",
    display: "flex",
    // justifyContent: 'center',
    // alignItems: 'center',
  },
  details: {
    width: "75%",
  },
  personInfo: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-end",
    flexDirection: "column",
    width: "25%",
    "& img": {
      width: "170px",
      height: "160px",
      objectFit: "cover",
      borderRadius: "10px !important",
    },
    "& h3": {
      margin: "0",
      marginTop: "10px",
      textAlign: "center",
      color: "#000",
      fontFamily: "Inter",
      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25px",
    },
    "& p": {
      margin: "0",
      marginTop: "5px",
      textAlign: "center",
      color: "#979797",
      fontFamily: "Inter",
      fontSize: "24px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "25px",
    },
  },

  head: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    marginBottom: "30px",
    "& p": {
      margin: "0",
      fontSize: "32px",
    },
  },
  box: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    width: "210px",
    height: "100px",
    background: "rgba(128, 0, 128, 0.15)",
    "& h3": {
      margin: "0",
      fontSize: "36px",
      textTransform: "capitalize",
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      fontSize: "16px !important",
    },
  },
  span1: {
    fontWeight: "600",
    fontSize: "36px",
  },
  span3: {
    color: "#979797",
    margin: "0",
  },

  outcome: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  redText: {
    color: "#FF0000",
  },
  dispensed: {
    display: "flex",
    // justifyContent: 'center',
    alignItems: "center",
    flexDirection: "column",
    "& h3": {
      fontWeight: "400",
      fontSize: "36px",
      margin: "0",
      marginBottom: "10px",
    },
  },
  quantity: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    "& h3": {
      margin: "0",
      fontSize: "85px",
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      fontSize: "20px ",
    },
  },
  radioContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "20px",
    "& .mantine-1svz3tp": {
      color: "#232323",
      fontFamily: "Inter",
      fontSize: "24px",
      fontWeight: "800",
      lineHeight: "25px",
    },
    "& .mantine-1cu6yj8:checked": {
      background: "#FFBA45",
      borderColor: "#FFBA45",
    },
  },
  wasEffectiveRadioContainer: {
    width: "50%",
  },
  effectiveContainer: {
    display: "flex",
    alignItems: "center",
    padding: "3rem 4rem 5rem 8rem",
    "& button": {
      color: "#000000",
      background: "rgba(128, 0, 128, 0.25)",
      fontSize: 20,
    },
    "& button:hover": {
      background: "rgba(128, 0, 128, 0.25)",
      // background:""
    },
  },
  info: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    borderBottom: "3px solid #979797",
    background: "#F2F2F2",
    marginTop: "20px",
    gap: "20px",
    paddingInline: "30px",
    paddingBlock: "10px",
    "& .column1": {
      flex: 1,
      "& p": {
        textAlign: "left",
      },
      "& h3": {
        textAlign: "left",
      },
    },
    "& .column2": {
      "& h3": {
        color: "#5C5C5C",
        fontStyle: "normal",
        fontWeight: 300,
        lineHeight: "25px",
        paddingLeft: "20px",
      },
    },
    "& p": {
      margin: "0",
      textAlign: "center",
      color: "#979797",
      fontFamily: "Inter",
      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "25px",
      marginBottom: "20px",
    },
    "& h3": {
      margin: "0",
      textAlign: "center",
      color: "#000",
      fontFamily: "Inter",
      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: "600",
      lineHeight: "25px",
    },
  },
  comments: {
    "& .mantine-1ix1d88": {
      borderRadius: "15px",
    },
  },

  upcomingHeader: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    background: "#bf80bf",
    overflow: "hidden",
    borderRadius: "1rem 1rem 0 0",
    height: "118px",
    gap: "20px",
    "& h2": {
      margin: "0",
      fontSize: "30px",
    },
  },

  quantityInput: {
    "& input": {
      borderRadius: "5px",
      width: "160px",
      height: "100px",
      border: "1px solid #979797",
      fontSize: "60px",
      fontWeight: "bold",
      textAlign: "center",
    },
  },
  medicationBox: {
    marginBottom: "20px",
  },
  saveButton: {
    marginTop: "50px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "& button": {
      borderRadius: "5px",
      background: "rgba(255, 186, 69, 0.85)",
      width: "145px",
      height: "60px",
      color: "#000",

      fontSize: "26px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "rgba(255, 186, 69, 0.85)",
      },
    },
  },
  updateButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& img": {
      width: "25px",
      height: "25px",
      marginRight: "2px",
    },
    "& button": {
      borderRadius: "5px",
      background: "rgba(255, 186, 69, 0.85)",
      width: "auto",
      height: "40px",
      color: "#000",

      fontSize: "20px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        background: "rgba(255, 186, 69, 0.85)",
      },
    },
  },
  editButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& button": {
      borderRadius: "5px",
      background: "transparent",
      width: "auto",
      height: "auto",
      color: "#fab005",

      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        color: "rgba(255, 186, 69, 0.85)",
        background: "transparent",
      },
    },
  },
  prnSelectBox: {
    "& .mantine-Select-input": {
      background: "#F2F2F2",
      borderRadius: 15,
      minHeight: "1rem !important",
      height: "4rem !important",
    },
  },
  editButton: {
    marginBlock: "10px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "10px",
    "& button": {
      borderRadius: "5px",
      background: "transparent",
      width: "auto",
      height: "auto",
      color: "#fab005",

      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "25px",

      "&:hover": {
        color: "rgba(255, 186, 69, 0.85)",
        background: "transparent",
      },
    },
  },

  // ── DRAWER STYLES ────────────────────────────────────────────────────
  drawerBody: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  modalTopBar: {
    width: "100%",
    height: "64px",
    flexShrink: 0,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 24px",
    borderBottom: "1px solid rgba(0,0,0,0.08)",
    backgroundColor: "#fff",
    borderRadius: "16px 16px 0 0",
  },
  modalTitle: {
    margin: 0,
    fontSize: "20px",
    fontWeight: 700,
    color: "#000",
    fontFamily: "Inter",
  },
  modalCloseBtn: {
    background: "none",
    border: "none",
    fontSize: "20px",
    cursor: "pointer",
    color: "#555",
    lineHeight: 1,
    padding: "4px 8px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.06)",
    },
  },
  formBox: {
    flex: 1,
    minHeight: 0,
    overflowY: "auto",
    backgroundColor: "#F5F5F5",
  },
  prnWrapper: {
    width: "100%",
    padding: "24px 20px",
  },
  // ── FIELD STYLES ─────────────────────────────────────────────────────
  inputStyle: {
    marginBottom: "12px",
    "& .mantine-Input-wrapper": {
      backgroundColor: "#FFFFFF",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
      "& .mantine-Input-input": {
        fontFamily: "Inter",
        border: "none",
        backgroundColor: "transparent",
        padding: "10px 14px",
        height: "44px",
        color: "#262626",
      },
      "& .mantine-Textarea-input": {
        height: "auto",
        overflowY: "auto",
        padding: "10px 14px",
      },
      "& .mantine-TimeInput-input, & .mantine-DateInput-input": {
        paddingLeft: 36,
      },
      "& .mantine-Select-rightSection svg, .mantine-MultiSelect-rightSection svg":
        {
          color: "#667085",
        },
    },
    "& .mantine-DatePickerInput-wrapper": {
      "& .mantine-DatePickerInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },
      "& .mantine-DatePickerInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-TimeInput-wrapper": {
      "& .mantine-TimeInput-icon": {
        "& svg": {
          color: "#262626",
          fontSize: 18,
        },
      },
      "& .mantine-TimeInput-input": {
        paddingLeft: "36px !important",
      },
    },
    "& .mantine-InputWrapper-label": {
      color: "#262626",
      marginBottom: "6px",
      fontFamily: "Inter",
      fontSize: "14px",
      fontWeight: 500,
    },
  },
  medicineCard: {
    background: "#FCFCFC",
    borderRadius: 16,
    border: "1px solid #E5E5E5",
    padding: "15px 13px",
    marginBottom: "16px",
  },
  accordionSelectItem: {
    borderRadius: "12px !important",
    background: "#F5F5F5 !important",
    border: "none !important",
    boxShadow: "none !important",
    overflow: "hidden",
    marginBottom: "0 !important",
    "&[data-active]": {
      background: "#F5F5F5 !important",
    },
  },
  accordionSelectControl: {
    fontSize: "14px",
    fontFamily: "Inter",
    color: "#262626",
    fontWeight: 500,
    minHeight: "48px !important",
    padding: "0 16px !important",
    background: "transparent !important",
    "& .mantine-Accordion-chevron": {
      color: "#262626",
    },
  },
  effectiveRadioPanel: {
    background: "#FFFFFF",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    padding: "14px 16px",
    margin: "0 0 12px 0",
  },
  quantityRow: {
    alignItems: "center",
    border: "1px solid #D0D5DD",
    borderRadius: "8px",
    overflow: "hidden",
    background: "#FAFAFA",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
    paddingInline: "13px",
  },
  qtyBtn: {
    width: "26px !important",
    minWidth: "26px",
    height: "26px !important",
    minHeight: "26px",
    borderRadius: "50% !important",
    background: "#FFF !important",
    boxShadow: "0 0 4px 0 rgba(0, 0, 0, 0.25)",
    border: "none !important",
    color: "#000000",
    "&:hover": {
      background: "#EBEBEB !important",
    },
  },
  qtyInput: {
    flex: 1,
    height: "44px",
    border: "none",
    outline: "none",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: 400,
    fontFamily: "Inter",
    color: "#262626",
    background: "transparent",
    padding: "0 8px",
    width: "100%",
    MozAppearance: "textfield",
    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button": {
      WebkitAppearance: "none",
      margin: 0,
    },
  },
  prnSaveBtn: {
    padding: "10px 22px",
    borderRadius: 8,
    border: "1px solid #FFAF4A",
    background: "#FFAF4A",
    color: "#262626",
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    cursor: "pointer",
    boxShadow: "0 1px 2px 0 rgba(16,24,40,0.05)",
    transition: "background .12s ease",
    "&:disabled": {
      border: "1px solid #E5E5E5",
      background: "#E5E5E5",
      color: "#A8A8A8",
      cursor: "not-allowed",
      boxShadow: "none",
    },
  },

  prnCancelBtn: {
    padding: "10px 22px",
    background: "transparent",
    border: "transparent",
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#262626",
    cursor: "pointer",
  },
  medicineInnerCard: {
    padding: "8px 12px",
    background: "#FFF",
    borderRadius: 8,
    border: "1px solid #CBD5E1",
    boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  },
  datetimeInput: {
    "& .mantine-Input-wrapper": {
      "& .mantine-Input-input": {
        padding: "10px 14px 10px 36px",
      },
      "& .mantine-TextInput-icon svg": {
        color: "#3F3F46",
      },
    },
  },

  // ── VIEW DRAWER STYLES ────────────────────────────────────────────
  modalBackBtn: {
    background: "none",
    border: "none",
    fontSize: "14px",
    cursor: "pointer",
    color: "#555",
    lineHeight: 1,
    padding: "6px 8px",
    borderRadius: "6px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontFamily: "Inter",
    fontWeight: 500,
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.06)",
    },
  },
  viewClientCard: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#FFFFFF",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    padding: "12px 16px",
    marginBottom: 16,
  },
  clientAvatar: {
    width: 44,
    height: 44,
    borderRadius: 8,
    objectFit: "cover",
  },
  clientName: {
    fontSize: "14px !important",
    fontWeight: "600 !important",
    color: "#000 !important",
    fontFamily: "Inter",
  },
  clientId: {
    fontSize: "12px !important",
    color: "#8C8C8C !important",
    fontFamily: "Inter",
  },
  prnBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 12px",
    borderRadius: 16,
    backgroundColor: "#F9F5FF",
    color: "#6941C6",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
  },
  unlimitedBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 12px",
    borderRadius: 16,
    background: "#F2F4F7",
    color: "#344054",
    fontSize: 14,
    fontWeight: 500,
    fontFamily: "Inter",
  },
  narcoticBadge: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "2px 8px",
    borderRadius: 6,
    background: "#FFF3E0",
    border: "1px solid #FFB74D",
    color: "#E65100",
    fontSize: 11,
    fontWeight: 600,
    fontFamily: "Inter",
  },
  medDetailsCard: {
    background: "#F5F5F5",
    borderRadius: 12,
    border: "1px solid #E5E5E5",
    padding: "14px 16px",
    marginBottom: 16,
  },
  medDetailsTitle: {
    fontSize: "15px",
    fontWeight: 600,
    fontFamily: "Inter",
    color: "#171717",
    margin: 0,
  },
  editBtnOrange: {
    backgroundColor: "#FFAF4A",
    color: "#171717",
    borderRadius: "8px",
    fontSize: "14px",
    fontFamily: "Inter",
    fontWeight: "600",
    height: "40px !important",
    padding: "0 16px !important",
    border: "none !important",
    "&:hover": { backgroundColor: "#FFAF4A", opacity: 0.8 },
  },
  cancelBtn: {
    backgroundColor: "#F9FAFB",
    color: "#1D2939",
    border: "1px solid #D0D5DD !important",
    borderRadius: "8px",
    fontSize: "14px",
    fontWeight: "600",
    height: "40px",
    fontFamily: "Inter",
    padding: "0 16px !important",
    "&:hover": { backgroundColor: "#F9FAFB", opacity: 0.8 },
  },
  editBtnSmall: {
    color: "#FBAA0D !important",
    fontSize: "13px !important",
    fontWeight: "600 !important",
    "&:hover": {
      background: "rgba(251, 170, 13, 0.08) !important",
    },
  },
  medDetailsInner: {
    background: "#FFFFFF",
    borderRadius: 10,
    border: "1px solid #E5E5E5",
    padding: "12px 16px",
    width: "100%",
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
  },
  medDetailsCol: {
    flex: 1,
    minWidth: 80,
  },
  medDetailsLabel: {
    fontSize: "12px",
    fontWeight: 400,
    color: "#8C8C8C",
    fontFamily: "Inter",
    margin: "0 0 6px 0",
  },
  medDetailsValue: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#262626",
    fontFamily: "Inter",
    margin: 0,
  },
  medDetailsSigImg: {
    height: 36,
    maxWidth: "100%",
    objectFit: "contain",
  },
  medDetailsSigText: {
    fontSize: "18px",
    fontWeight: 400,
    fontFamily: "Island Moments",
    color: "#171717",
    lineHeight: "normal",
    margin: 0,
  },
  editDetailsGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: 12,
    width: "100%",
  },
  sigBox: {
    background: "#F5F5F5",
    minHeight: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4px 8px",
  },
  timeInputLeftIcon: {
    pointerEvents: "all",
    cursor: "pointer",
  },
  medicineDetailsCard: {
    background: "#F5F5F5",
    borderRadius: 8,
    border: "1px solid #E5E5E5",
    padding: 8,
    marginBottom: "16px",
  },
  medFreqAndCountRow: {
    alignItems: "center",
    justifyContent: "space-between",
    paddingBlock: 7,
    borderBottom: "1px solid #E5E5E5",
    "& .freqAndTime": {
      "& .frequency": {
        fontSize: "16px",
        fontWeight: 600,
        color: "#404040",
        fontFamily: "Inter",
        margin: 0,
      },
      "& .time": {
        fontSize: "10px",
        fontWeight: 400,
        color: "#737373",
        fontFamily: "Inter",
        margin: 0,
      },
    },
  },
  remainingText: {
    fontSize: "12px",
    color: "#5C5C5C",
    fontFamily: "Inter",
    margin: 0,
  },
  quantityAndInfoRow: {
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "space-between",
    marginBlock: 12,
    paddingBottom: 12,
    "& .name": {
      fontSize: "14px",
      fontWeight: 600,
      color: "#404040",
      fontFamily: "Inter",
      margin: 0,
    },
    "& .dosage": {
      fontSize: "10px",
      fontWeight: 400,
      color: "#737373",
      fontFamily: "Inter",
      margin: 0,
    },
  },
  viewQtyNumber: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#404040",
    fontFamily: "Inter",
    margin: 0,
  },
  viewQtyLabel: {
    fontSize: "10px",
    fontWeight: 400,
    color: "#737373",
    fontFamily: "Inter",
    margin: 0,
  },
  viewInfoBox: {
    backgroundColor: "#F5F5F5",
    borderRadius: 8,
    padding: "10px 12px",
    marginBottom: 12,
  },
  viewInfoRow: {
    justifyContent: "space-between",
    gap: 12,
  },
  viewInfoLabel: {
    fontSize: "11px",
    fontWeight: 400,
    color: "#737373",
    fontFamily: "Inter",
    margin: "0 0 4px 0",
  },
  viewInfoValue: {
    fontSize: "13px",
    fontWeight: 600,
    color: "#262626",
    fontFamily: "Inter",
    margin: 0,
  },
  reasonSection: {
    marginTop: 4,
  },
  reasonLabel: {
    fontSize: "11px",
    fontWeight: 400,
    color: "#737373",
    fontFamily: "Inter",
    margin: "0 0 4px 0",
  },
  reasonValue: {
    fontSize: "12px",
    fontWeight: 700,
    color: "#171717",
    fontFamily: "Inter",
    margin: 0,
  },
  labelStyle: {
    color: "#262626",
    fontFamily: "Inter",
    fontSize: "14px",
    fontWeight: 500,
    margin: 0,
    marginBottom: "6px",
  },

  // ── NEW-PRN DRAWER ────────────────────────────────────────────────────
  prnSubtitle: {
    margin: "2px 0 0",
    fontSize: 12,
    color: "#525252",
    fontFamily: "Inter",
  },
  prnFooter: {
    padding: "14px 22px",
    borderTop: "1px solid #E5E5E5",
    display: "flex",
    justifyContent: "space-between",
    gap: 8,
    background: "#FFFFFF",
    borderRadius: "0 0 16px 16px",
    flexShrink: 0,
  },
  prnRadioCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    border: "1px solid #E5E5E5",
    borderRadius: 8,
    background: "#FFFFFF",
    cursor: "pointer",
    transition: "background .12s ease",
    "&:hover": {
      background: "#FAFAFA",
    },
  },
  prnSelectedCard: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 12px",
    border: "1px solid #FFAF4A",
    borderRadius: 8,
    background: "#FFFBF1",
    marginBottom: 8,
  },

  prnQtyStaffRow: {
    display: "flex",
    gap: 12,
    marginBottom: 12,
  },
  prnMedInfoRow: {
    marginTop: 8,
    padding: "12px 14px",
    border: "1px solid #E5E5E5",
    borderRadius: 8,
    background: "#FFFFFF",
    display: "flex",
    gap: 16,
    flexWrap: "wrap",
    marginBottom: 16,
  },
  prnEmptyState: {
    padding: 24,
    textAlign: "center",
    color: "#A8A8A8",
    fontSize: 13,
    fontFamily: "Inter",
    background: "#FAFAFA",
    borderRadius: 8,
    border: "1px dashed #E5E5E5",
  },
  pillIconWrap: {
    width: 34,
    height: 34,
    borderRadius: 8,
    background: "#FFF3DC",
    border: "1px solid #FFE4A8",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#92400E",
  },
  pillIconWrapNarcotic: {
    width: 34,
    height: 34,
    borderRadius: 8,
    background: "#FEE2E2",
    border: "1px solid #FECACA",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    color: "#B91C1C",
  },
}));

export default useStyles;
